module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('div', {
    staticClass: "row card"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Group Name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.group.name),
      expression: "group.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.group.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.group, "name", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Policies"), _c('SelectizePolicy', {
    attrs: {
      "selectedValues": _vm.group.policies,
      "maxItems": null
    },
    on: {
      "optionSelected": _vm.updatePolicies,
      "optionRemoved": _vm.removePolicies
    }
  })], 1)]), _c('div', {
    staticClass: "column"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.group.global),
      expression: "group.global"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.group.global) ? _vm._i(_vm.group.global, null) > -1 : (_vm.group.global)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.group.global,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.group, "global", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.group, "global", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.group, "global", $$c)
        }
      }
    }
  }), _c('label', [_vm._v("Add all Drivers")]), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.group.global),
      expression: "!group.global"
    }]
  }, [_vm._v("Drivers"), _c('SelectizeDriver', {
    ref: "selectizeDrivers",
    attrs: {
      "maxItems": null
    },
    on: {
      "optionSelected": _vm.updateDrivers,
      "optionRemoved": _vm.removeDrivers
    }
  })], 1)])]), (_vm.group.id !== null && !_vm.group.global) ? _c('div', {
    staticClass: "row"
  }, [(_vm.loaded) ? _c('div', {
    staticClass: "column"
  }, [_c('base-list', {
    attrs: {
      "component": _vm.componentDriver,
      "dataLoader": _vm.loadDrivers,
      "componentType": "groupList",
      "selectableList": true,
      "resultsPerPage": 5
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1) : _vm._e()]) : _vm._e(), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.save,
      "disabled": _vm.group.name == null || _vm.group.name === ''
    },
    slot: "footer"
  }, [_vm._v("Save")]), _c('button', {
    staticClass: "button alert float-right",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": function($event) {
        return _vm.$refs[_vm.componentId].close()
      }
    },
    slot: "footer"
  }, [_vm._v("Cancel")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31856d6c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/GroupEdit.vue
// module id = 2393
// module chunks = 1